import React from 'react';
import About from './AboutSection';
import AboutSlider from './AboutSliderSection';
import Testimonial from './TestimonialSection';
import Service from './ServiceSection';
import ServiceTwo from './ServiceSectionTwo';
import Project from './ProjectSection';
import Counter from './CounterSection';
import CTA from './CTASection';
import Team from './TeamSection';
import ScrollToTop from '../../components/Common/ScrollTop';
import BannerHomeThirteen from '../../components/Banner/BannerHomeThirteen';
import OnepageContactPart from '../../components/Contact/OnepageContact';

const HomeThirteenOnepageMain = () => {
	return (
		<React.Fragment>
			{/* Slider-start */}
			<BannerHomeThirteen />
			{/* Slider-start */}

			{/* Service-start */}
			<Service />
			{/* Service-end */}

			{/* About-area-start */}
			<About />
			{/* About-area-end */}

			{/* Service-area-start */}
			<ServiceTwo />
			{/* Service-area-end */}


			{/* About Slider-start */}
			<AboutSlider />
			{/* About Slider-end */}

			{/* Counter-start */}
			<Counter />
			{/* Counter-end */}

			{/* Project-start */}
			<Project />
			{/* Project-end */}

			{/* Testimonial-start */}
			<Testimonial />
			{/* Testimonial-end */}

			{/* CTA-area-start */}
			<CTA />
			{/* CTA-area-end */}

			{/* Team-area-start */}
			<Team />
			{/* Team-area-end */}

			{/* Contact-area-start */}
			<OnepageContactPart 
				contactSectionClass="rs-contact gray-bg pt-120 md-pt-80"
				contactSubTitleClass="sub-title purple-color"
				contactSectionTitleClass="title testi-title"
				contactBoxClass="contact-box purple-box"
				submitBtnClass="readon started submit get-ready4"
			/>
			{/* Contact-area-end */}

			{/* scrolltop-start */}
			<ScrollToTop 
				scrollClassName="scrollup purple-color"
			/>
			{/* scrolltop-end */}

		</React.Fragment>
	);
}

export default HomeThirteenOnepageMain;